<template>
    <div v-if="loading">
        <SpinnerIOS/>
    </div>
    <div class="container mt-4 mb-5">
        <div class="row align-items-start">
            <div class="col-1 text-end">
                <p v-if="eventId" style="cursor: pointer;">
                    <button type="button" @click="showNews" class="btn btn-outline-light btn-sm text-dark no-border">
                        ... <i class="bi bi-reply fs-4"></i>
                    </button>
                </p>
            </div>
            <div class="col-11 mb-5 shadow-sm p-3 mb-5 bg-body rounded">
                <div v-html="dataMain.content" class="content-text"></div>
            </div>
        </div>
        <div class="ps-5 ms-5 mt-5">
            <!-- Yangiliklar -->
            <div class="section-animate">
                <h3 class="mb-4 section-title text-muted">{{ translations[language].latestNews }}</h3>
                <div class="row row-cols-1 row-cols-md-4 g-4 section-cards">
                    <div class="col" v-for="news in dataNews" :key="news.id">
                        <div class="card h-100 shadow-sm border-0 rounded-3 overflow-hidden"
                            @click="allNews"
                            style="cursor: pointer"
                        >
                            <div class="position-relative">
                                <img
                                    :src="news.image || '/media/default_thumbnail.jpg'"
                                    :alt="news.title"
                                    class="card-img-top"
                                    style="object-fit: cover; height: 180px;"
                                />
                                <div
                                    class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                    <i class="bi bi-file-earmark-text text-white fs-3"></i>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-truncate fw-bold" :title="news.title">
                                    {{ news.title.length > 50 ? news.title.slice(0, 50) + '...' : news.title }}
                                </h5>
                            </div>
                            <div class="card-footer bg-transparent border-0">
                                <small class="text-muted">{{ formatDate(news.created_at) }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row text-center mt-2 section-title">
                    <div class="col">
                        <button type="button" @click="allNews"
                                class="btn btn-outline-light btn-sm text-dark no-border guid-button">
                            <h4>{{ translations[language].allNews }} <i
                                class="bi bi-arrow-up-right-square text-muted"></i></h4>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Foto Galereya -->
            <div class="section-animate mt-4">
                <h3 class="mb-4 section-title text-muted">{{ translations[language].photoGallery }}</h3>
                <div class="row row-cols-1 row-cols-md-4 g-4 section-cards">
                    <div class="col" v-for="gallery in dataGalarey" :key="gallery.id">
                        <div
                            class="card h-100 shadow-sm border-0 rounded-3 overflow-hidden"
                            @click="allImages"
                            style="cursor: pointer"
                        >
                            <div class="position-relative">
                                <img
                                    :src="gallery.preview_image"
                                    :alt="gallery.description"
                                    class="card-img-top"
                                    style="object-fit: cover; height: 180px;"
                                />
                                <div
                                    class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                    <i class="bi bi-image text-white fs-3"></i>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-truncate fw-bold" :title="gallery.description">
                                    {{
                                        gallery.description.length > 50 ? gallery.description.slice(0, 50) + '...' : gallery.description
                                    }}
                                </h5>
                            </div>
                            <div class="card-footer bg-transparent border-0">
                                <small class="text-muted">{{ formatDate(gallery.created_at) }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row text-center mt-2 section-title">
                    <div class="col">
                        <button type="button" @click="allImages"
                                class="btn btn-outline-light btn-sm text-dark no-border guid-button">
                            <h4>{{ translations[language].allPictures }} <i
                                class="bi bi-arrow-up-right-square text-muted"></i></h4>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Video Galereya -->
            <div class="section-animate mt-4">
                <h3 class="mb-4 section-title text-muted">{{ translations[language].videoGallery }}</h3>
                <div class="row row-cols-1 row-cols-md-4 g-4 section-cards">
                    <div class="col" v-for="gallery in dataVideoGalarey" :key="gallery.id">
                        <div
                            class="card h-100 shadow-sm border-0 rounded-3 overflow-hidden"
                            @click="allVideos"
                            style="cursor: pointer"
                        >
                            <div class="position-relative">
                                <img
                                    :src="gallery.thumbnail || '/media/default_thumbnail.jpg'"
                                    alt="Gallery Thumbnail"
                                    class="card-img-top"
                                    style="object-fit: cover; height: 180px;"
                                />
                                <div
                                    class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                    <i class="bi bi-play text-white fs-3"></i>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-truncate fw-bold" :title="gallery.description">
                                    {{
                                        gallery.description.length > 50 ? gallery.description.slice(0, 50) + '...' : gallery.description
                                    }}
                                </h5>
                            </div>
                            <div class="card-footer bg-transparent border-0">
                                <small class="text-muted">{{ formatDate(gallery.created_at) }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row text-center mt-2 section-title">
                    <div class="col">
                        <button type="button" @click="allVideos"
                                class="btn btn-outline-light btn-sm text-dark no-border guid-button">
                            <h4>{{ translations[language].allVideos }} <i
                                class="bi bi-arrow-up-right-square text-muted"></i></h4>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import SpinnerIOS from "@/components/SiteComponents/Main/Components/SpinnerIOS.vue";

export default {
    name: 'ContentComponent',
    components: {SpinnerIOS},
    props: {
        eventId: {
            type: [Number, String, null],
            default: null
        }
    },
    emits: ['showNews'],
    data() {
        return {
            loading: true,
            language: localStorage.getItem('language') || 'uz',
            dataMain: {},
            navbarId: localStorage.getItem('navbar_item') || 1,
            dataNews: [],
            dataNavbar: [],
            dataGalarey: [],
            dataVideoGalarey: [],
            savedPage: parseInt(localStorage.getItem('currentPage')) || 1,
            translations: {
                uz: {
                    latestNews: "So'ngi yangiliklar",
                    photoGallery: "Foto Galereya",
                    videoGallery: "Video Galereya",
                    allNews: "Barcha yangiliklar",
                    allPictures: "Barcha rasmlar",
                    allVideos: "Barcha videolar"
                },
                en: {
                    latestNews: "Latest News",
                    photoGallery: "Photo Gallery",
                    videoGallery: "Video Gallery",
                    allNews: "View All News",
                    allPictures: "View All Pictures",
                    allVideos: "View All Videos"
                },
                ru: {
                    latestNews: "Последние Новости",
                    photoGallery: "Фотогалерея",
                    videoGallery: "Видеогалерея",
                    allNews: "Все новости",
                    allPictures: "Все фотографии",
                    allVideos: "Все видео"
                }
            }
        };
    },
    methods: {
        async fetchContent() {
            this.loading = true;
            try {
                let url = `/main/${this.navbarId}/`;
                if (this.eventId) {
                    url = `/event/${this.eventId}/`;
                }
                const {data} = await api.get(url, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataMain = data;
            } catch (error) {
                console.error('Error fetching content:', error);
            } finally {
                this.loading = false;
                this.fetchNews(this.savedPage);
            }
        },
        async fetchNews(page = 1) {
            try {
                localStorage.setItem('currentPage', page);
                const {data} = await api.get(`/news/?page=${page}`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataNews = data.results.slice(0, 4);
            } catch (error) {
                console.error("Xatolik:", error);
            } finally {
                this.loading = false;
                this.fetchGalarey(this.savedPage);
            }
        },
        async fetchGalarey(page = 1) {
            try {
                localStorage.setItem("currentPage", page);
                const {data} = await api.get(`/image-galleries/?page=${page}`, {
                    headers: {
                        "Accept-Language": this.language,
                    },
                });
                this.dataGalarey = data.results.slice(0, 4);
            } catch (error) {
                console.error("Xatolik:", error);
            } finally {
                this.fetchVideoGalarey(this.savedPage);
            }
        },
        async fetchVideoGalarey(page = 1) {
            try {
                localStorage.setItem("currentPage", page);
                const {data} = await api.get(`/video-galleries/?page=${page}`, {
                    headers: {
                        "Accept-Language": this.language,
                    },
                });
                this.dataVideoGalarey = data.results.slice(0, 4);
            } catch (error) {
                console.error("Xatolik:", error);
            } finally {
                this.loading = false;
            }
        },
        async fetchNavbar() {
            try {
                const {data} = await api.get(`/nav-item/`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataNavbar = data;
            } catch (error) {
                // Xatolikni e’tiborsiz qoldiramiz
            }
        },
        showNews() {
            this.$emit('showNews');
        },
        async allNews() {
            await this.fetchNavbar()
            const newsId = this.findFirstNewsId(this.dataNavbar);
            if (newsId) {
                localStorage.setItem("navbar_item", newsId);
                localStorage.setItem("navbar-type", 'news');
            }
            location.reload()
        },
        findFirstNewsId(items) {
            for (const item of items) {
                if (item.type === 'news') {
                    return item.id;
                }
                if (item.children && item.children.length) {
                    const childResult = this.findFirstNewsId(item.children);
                    if (childResult) return childResult;
                }
            }
            return null;
        },
        findFirstImageGalleryId(items) {
            for (const item of items) {
                if (item.type === 'foto_gallery') {
                    return item.id;
                }
                if (item.children && item.children.length) {
                    const childResult = this.findFirstImageGalleryId(item.children);
                    if (childResult) return childResult;
                }
            }
            return null;
        },
        findFirstVideoGalleryId(items) {
            for (const item of items) {
                if (item.type === 'video_gallery') {
                    return item.id;
                }
                if (item.children && item.children.length) {
                    const childResult = this.findFirstImageGalleryId(item.children);
                    if (childResult) return childResult;
                }
            }
            return null;
        },
        async allImages() {
            await this.fetchNavbar()
            const imageGalleryId = this.findFirstImageGalleryId(this.dataNavbar);
            if (imageGalleryId) {
                localStorage.setItem("navbar_item", imageGalleryId);
                localStorage.setItem("navbar-type", 'foto_gallery');
            }
            location.reload()
        },
        async allVideos() {
            await this.fetchNavbar()
            const videoGalleryId = this.findFirstVideoGalleryId(this.dataNavbar);
            if (videoGalleryId) {
                localStorage.setItem("navbar_item", videoGalleryId);
                localStorage.setItem("navbar-type", 'video_gallery');
            }
            location.reload()
        },
        formatDate(dateString) {
            if (!dateString) return this.translations[this.language].invalidDate || 'Sana mavjud emas';
            const date = new Date(dateString);
            if (isNaN(date)) return this.translations[this.language].invalidDate || 'Noto‘g‘ri sana';

            if (this.language === 'uz') {
                const months = [
                    'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
                    'iyul', 'avgust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'
                ];
                const day = date.getDate();
                const month = months[date.getMonth()];
                const year = date.getFullYear();
                return `${day}-${month}, ${year}`;
            }

            const options = {year: 'numeric', month: 'long', day: 'numeric'};
            const locale = this.language === 'ru' ? 'ru-RU' : 'en-US';
            return new Intl.DateTimeFormat(locale, options).format(date);
        },
    },
    watch: {
        eventId: {
            handler() {
                this.fetchContent();
            },
            immediate: true
        },
        navbarId() {
            if (!this.eventId) {
                this.fetchContent();
            }
        }
    },
};
</script>

<style scoped>
.content-text {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #333;
}

/* Har bir bo‘lim uchun umumiy konteyner */
.section-animate {
    opacity: 0;
    animation: fadeInUp 0.6s ease-out forwards;
}

/* Sarlavha va kartalar uchun alohida animatsiya kechikishlari */
.section-title {
    opacity: 0;
    animation: fadeInUp 0.6s ease-out forwards;
    animation-delay: 0.8s;
}

.guid-button:hover {
    background-color: #e9ecef;
    border-radius: 5px;
}

.section-cards {
    opacity: 0;
    animation: fadeInUp 0.6s ease-out forwards;
    animation-delay: 0.2s;
}

/* Har bir bo‘lim uchun kechikish */
.section-animate:nth-child(1) {
    animation-delay: 0s;
}

.section-animate:nth-child(2) {
    animation-delay: 1.0s;
}

.section-animate:nth-child(3) {
    animation-delay: 2.0s;
}

.card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.card .position-relative {
    position: relative;
    overflow: hidden;
}

.card-img-top {
    transition: transform 0.3s ease;
    z-index: 1;
}

.card:hover .card-img-top {
    transform: scale(1.05);
    z-index: 1;
}

.overlay {
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease, background-color 0.3s ease;
    opacity: 0;
    z-index: 2;
}

.card:hover .overlay {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.4);
}

.card-title {
    font-size: 1.1rem;
    color: #212529;
}

.card-footer {
    padding-bottom: 1rem;
}

.text-center {
    color: #212529;
    font-weight: 600;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .card-title {
        font-size: 1rem;
    }

    .card-img-top {
        height: 150px;
    }
}
</style>
